const prefix = 'fac';
const iconName = 'folder-pause';
const width = 512;
const height = 512;
const ligatures = [];
const unicode = null;
const svgPathData = 'M192 32C212.1 32 231.1 41.4997 243.2 57.5996L262.4 83.2002C268.4 91.3 277.9 96 288 96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.7 480 0 451.3 0 416V96C0 60.7 28.7 32 64 32H192ZM192 191C174.327 191 160 205.327 160 223V351C160 368.673 174.327 383 192 383C209.673 383 224 368.673 224 351V223C224 205.327 209.673 191 192 191ZM320 191C302.327 191 288 205.327 288 223V351C288 368.673 302.327 383 320 383C337.673 383 352 368.673 352 351V223C352 205.327 337.673 191 320 191Z';

export const definition = {
    prefix,
    iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData,
    ],
};

export { definition as faFolderPause };
